import { TrustAPI } from '@/shared/modules/trust-api';
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import HelpEditModal from '../help-edit-modal/index.vue';
import { AppInsights } from '@/trust-atcs-app/appInsights';
import { PageContent } from '@/shared/modules/typescript-trustapi-client/models';

@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    HelpEditModal
  }
})
export default class TrustDataPageSettings extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private tableHeadings = [
    { text: 'Page', value: 'page', sortable: false },
    { text: 'Type', value: 'type', sortable: false },
    { text: 'Title', value: 'title', sortable: false },
    { text: 'Internal Note', value: 'internal-note', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Actions', value: 'actions', sortable: false },
  ];


  private loadingContent = false;
  private errorLoadingContent = false;
  private pageSettingsList: any[] = [];
  private showPopoverEdit = false;
  private ai = new AppInsights;
  private selectedPageSettings: PageContent = null as any;

  created(): void {
    this.loadPageSettingsList();
  }

  mounted() {
    this.eventCtrl.on('reload-page-settings', this.loadPageSettingsList);
  }

  beforeUnmount() {
    this.eventCtrl.off('reload-page-settings', this.loadPageSettingsList);
  }

  private async loadPageSettingsList(): Promise<void> {
    try {
      this.loadingContent = true;
      const response: any = await this.apiService.PageAtcsApi?.apiV2PageAtcsAdminGetAllPageContentsGet();
      this.pageSettingsList = response.data.data;
    } catch (err: any) {
      this.errorLoadingContent = true;
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting page list: ' + err.response?.status);
      this.ai.trackException('Error getting content page: ' + err);
    } finally {
      this.loadingContent = false;
    }

  }

  private async pageContentStatus(p: PageContent, value: any): Promise<void> {
    try {
      this.pageSettingsList.forEach((item: any, index: number) => {
        if (item.id === p.id) {
          this.pageSettingsList[index].isShow = value;
        }
      });
      await this.apiService.PageAtcsApi?.apiV2PageAtcsAdminUpdatePageContentStatusPost({
        id: p.id,
        isShow: value ?? false,
      });
    } catch (err: any) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting page list: ' + err.response?.status);
      this.ai.trackException('Error getting content page: ' + err);
    } finally {
      this.loadingContent = false;
    }
  }


  private editPageSettings(settingType: PageContent): void {
    this.showPopoverEdit = true;
    this.selectedPageSettings = settingType;
  }


  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }
}
